import comp from "./PdfTronView";
export default comp;
